import React, { useEffect, useRef } from 'react';

import { useProfileState, useProfileActions } from './ProfileContext';

import SearchBar from '../../Shared/UI/SearchBar/components/SearchBar';

import { getSkills } from './restApi';

const NewUnrecognizedSkillFormForModal = () => {
  const state = useProfileState();
  const { onResponse, onError, setSkillsModalToLoading, updateDebouncedSkillNameForFuzzyFilter, updateNewSkillName } = useProfileActions();
  const searchBarRef = useRef(null);

  useEffect(() => {
    setSkillsModalToLoading();

    const handler = setTimeout(() => {
      updateDebouncedSkillNameForFuzzyFilter(state?.skillsModal?.newUnrecognizedSkillForm?.skillName);
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [state?.skillsModal?.newUnrecognizedSkillForm?.skillName]);

  useEffect(() => {
    getSkills({
      onResponse,
      onError,
      pageNumber: 1,
      debouncedSkillNameForFuzzyFilter: state?.skillsModal?.newUnrecognizedSkillForm?.debouncedSkillNameForFuzzyFilter,
      skillName: state?.skillsModal?.newUnrecognizedSkillForm?.skillName,
    });
  }, [state?.skillsModal?.newUnrecognizedSkillForm?.debouncedSkillNameForFuzzyFilter]);

  useEffect(() => {
    if (state.userSkillsModalIsOpen && searchBarRef.current) {
      // Small delay to ensure modal is fully rendered
      const timeoutId = setTimeout(() => {
        searchBarRef.current?.focus();
      }, 100);
      return () => clearTimeout(timeoutId);
    }
  }, [state.userSkillsModalIsOpen]);

  return (
    <SearchBar
      ref={searchBarRef}
      placeholder="Search Skill And Add If Not Found..."
      value={state?.skillsModal?.newUnrecognizedSkillForm?.skillName}
      onChange={
        (e) => {
          updateNewSkillName(e.target.value);
        }
      }
    />
  );
};

export default NewUnrecognizedSkillFormForModal;
